<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("Vip Fnb") }}</div>
      </div>
      <div>
        <!-- <b-button
          variant="default"
          to="/fnb/add-edit-vip-fnb"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        > -->
      </div>
    </div>

    <table class="list-view-table mt-4" v-if="listView">
      <thead>
        <tr>
          <th>{{ $tc("Qr Code", 1) }}</th>
          <th>{{ $tc("Qr Code Url", 1) }}</th>

          <th>Preview</th>

          <th>{{ $tc("Action", 1) }}</th>
        </tr>
      </thead>
      <tbody v-if="GetvipfnbArray.length > 0">
        <tr v-for="(item, key) in GetvipfnbArray" :key="key">
          <td>
            <img src="@/assets/img/vip_fnb_qr.png" />
          </td>
          <td class=""
            ><a :href="item.vip_path" target="_blank">{{
              item.vip_path
            }}</a></td
          >

          <td>
            <a v-if="item.vip_path" :href="item.vip_path" target="_blank">
              <img
                src="@/assets/img/icons/empty-image.svg"
                height="35"
                width="35"
                class="rounded"
              /> </a
          ></td>
          <!-- <td>
            <span @click="onClickStatusDot(item)">
              <StatusDot
                :status="item.vip_is_active == 'Y' ? 'active' : 'inactive'"
              /> </span
          ></td> -->
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <b-dropdown
                right
                variant="edit"
                class="ml-4"
                v-if="$can('update', 'VipFnb')"
              >
                <b-dropdown-item
                  @click="goToRoute('/fnb/add-edit-vip-fnb/', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <!-- <b-dropdown-item
                  @click="goToRoute('/master/view-currency-conversion', item)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item> -->
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-if="GetvipfnbArray.length == 0">
        <tr>
          <td colspan="3">
            <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>
    <!-- 
    <b-pagination
      v-if="GetvipfnbArray.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination> -->

    <!-- <b-modal
      id="confirmation_active_inactive"
      title="Confirmation"
      hide-footer
      hide-header
      centered
    >
      <div class="text-center pb-1 my-3">
        <p class="fs-16 mb-3"
          >Are you sure you want to
          {{ selectedPop.vip_is_active == "Y" ? "Inactive" : "Active" }} this
          Signage Display?</p
        >
        <span class="mx-1"></span>
        <button
          v-if="selectedPop.vip_is_active == 'N'"
          class="btn btn-success btn-success-lg px-4 fs-14"
          @click.prevent.stop="UpdateStatus('Y')"
        >
          Active
        </button>
        <button
          v-else
          class="btn btn-danger btn-danger-lg px-4 fs-14"
          @click.prevent.stop="UpdateStatus('N')"
        >
          Inactive
        </button>
        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('confirmation_active_inactive')"
        >
          Cancel
        </button>
      </div>
    </b-modal> -->
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import CurrenciesConversion from "@/helper/formJSONMaster/CurrenciesConversion";
  import StatusDot from "@/components/Partials/StatusDot.vue";
  import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import ExhibitorService from "@/services/ExhibitorService";
  import signageServices from "@/services/signageService";
  import PosFnbService from "@/services/PosFnbService";
  import { CLIENT_NAME } from "@/helper/Role";

  export default {
    components: {
      StatusDot,
      FilterByStatusDropdown,
      NoRecords,
    },
    // name: "EditVipfnb",
    data() {
      return {
        isRoleID: false,
        selectedPop: {
          vip_id: null,
          pp_type_id: null,
          pp_name: "",
          pp_lang_id: null,
          pp_rating_type: "",
          pp_banner: "",
          pp_title: "",
          pp_country_id: "",
          pp_image_url: "",
          pp_description: "",
          vip_is_active: "Y",
        },
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        dropdownstatus: [
          { id: 1, value: "", name: "All" },
          { id: 2, value: "Y", name: "Active" },
          { id: 3, value: "N", name: "Inactive" },
        ],
        selectedDropdownStatus: "",
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",

        gridView: false,
        listView: true,
        Methods: CurrenciesConversion.Methods,
        Currencies: [],
        viewingnumbers: [],
        customErrors: {
          message: "",
        },
        GetvipfnbArray: [],
        signage_url: "",
      };
    },
    computed: {
      QfxClient() {
        return CLIENT_NAME.QFX == this.CLIENT_SETUP_NAME;
      },
    },
    watch: {
      selectedDropdownStatus(status) {
        this.selectedDropdownStatus = status;
        this.getVipfnbList();
      },
    },

    beforeMount() {
      let obj = this.secureStore.get("USINFO").cinema_id;

      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      if (CinemaObj) {
        this.selectedCinema = CinemaObj.cine_name;
        this.selected_cine_id = CinemaObj.cine_id;
        // this.getAllReturnGoods(CinemaObj.cine_id);
      }

      this.getVipfnbList();
      //   this.getviewingnumber();
      //   this.getCinemaList();
    },

    methods: {
      onClickStatusDot(item) {
        console.log("CLICKING onClickStatusDot", item);
        this.selectedPop = _.cloneDeep(item);
        this.$bvModal.show("confirmation_active_inactive");
      },

      /* eslint-disable */
      //   onChangePagination: function(event) {
      //     if (event === undefined) {
      //       this.currentPage = 1;
      //       this.getVipfnbList();
      //     } else {
      //       this.currentPage = event;
      //       this.getVipfnbList();
      //     }
      //   },
      goToRoute: function(path, item) {
        console.log("item :", item);
        const { vip_id } = item;
        this.$router.push({
          path: `${path}?vip_id=${vip_id}`,
        });
      },

      //   UpdateStatus(status) {
      //     let loader = this.$loading.show();
      //     this.$bvModal.hide("confirmation_active_inactive");

      //     let payload = {
      //       vip_id: this.selectedPop["vip_id"],
      //       vip_is_active: status
      //         ? status
      //         : this.selectedPop["vip_is_active"] == "Y"
      //         ? "N"
      //         : "Y",
      //     };
      //     signageServices
      //       .UpdateSignageStatus(payload)
      //       .then((response) => {
      //         const { data } = response;
      //         this.getVipfnbList();
      //         console.log(data.message);
      //       })
      //       .catch((err) => {
      //         console.log(err);
      //       })
      //       .finally(() => {
      //         setTimeout(() => loader.hide(), 1000);
      //       });
      //   },

      getVipfnbList() {
        let loader = this.$loading.show();
        let payload = {
          //   vip_id: vip_id,

          //   limit: this.perPage,
          //   currentPage: this.currentPage,
          vip_is_active: this.selectedDropdownStatus.value,
        };
        this.GetvipfnbArray = [];
        PosFnbService.GetVipFnb(payload)
          .then((response) => {
            const { data } = response;
            loader.hide();
            if (data.status) {
              if (data.Records.length > 0) {
                this.GetvipfnbArray = data.Records;
                // this.signage_url = data.signage_url;
                //   this.Currencies.map(x => {
                //     x["ccr_vip_is_active"] = x["ccr_vip_is_active"] == "Y" ? true : false;
                //   });
              } else {
                this.customErrors.message = data.message;
              }
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {});
      },

      //   viewType: function(viewType) {
      //     if (viewType == "gridView") {
      //       this.gridView = true;
      //       this.listView = false;
      //     } else if ((viewType = "listView")) {
      //       this.listView = true;
      //       this.gridView = false;
      //     }
      //   },
    },
  };
</script>
<style scoped>
  .text-white {
    color: white !important;
  }
  .text-ellipse {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnBComponents/vipfnb.vue